import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } 					                  from '@angular/core';
import { Router, ActivatedRoute }                                 from '@angular/router';
import { first }                                                  from 'rxjs/operators';
import { NgxSpinnerService }                                      from 'ngx-spinner';

import { AlertService, AuthenticationService }                    from '../_services';
import { Globals  }                                               from '../_helpers';
import config                                                     from '../../config';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Component({
  selector: 'instruction-page',
  templateUrl: './instruction.component.html',
})

export class InstructionComponent implements AfterViewInit, OnInit{

  public alertOption: SweetAlertOptions = {};  
    @ViewChild('createExamSwal') private createExamSwal: SwalComponent;
    @ViewChild('readInsSwal') private readInsSwal: SwalComponent;
    @ViewChild('msgSwal') private msgSwal: SwalComponent;
    @ViewChild('addinBatchSwal') private addinBatchSwal: SwalComponent;
    @ViewChild('videoPlayer') videoplayer: ElementRef;
    userinfo: any;
    studentid: number = 0;
  	instructions = [];
	loading = false;
	isCalled = true;
	returnUrl : string;
    usertoken: string;
    qpid: number = 0;
    sectorid: number = 0;
    examlist;
    examArrLength;
    isAvailableExam: number = 0;	

	constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private http: HttpClient
    ) {}

    ngOnInit() {
    this.userinfo = JSON.parse(localStorage.getItem('userinfo_ps')); //console.log(this.userinfo);
    this.studentid = this.userinfo['student_id'];
    this.usertoken = this.userinfo['usertoken'];
    var step = this.route.snapshot.paramMap.get("step");
    var step1 = this.route.snapshot.paramMap.get("step1");

    if(step == null || step == undefined)
    {
      this.returnUrl = '/dashboard';
    }
    else{
      this.qpid = parseInt(step);
    }   
    if(step1 == null || step1 == undefined)
    {
      this.returnUrl = '/dashboard';
    }
    else{
      this.sectorid = parseInt(step1);
    }      
    this.getInstruction();
    }
    toggleVideo(event: any) {
        this.videoplayer.nativeElement.play();
    }
    inspdf;
    insvideo;
    private getInstruction(){
        this.spinner.show();
        this.authenticationService.getInstructions(this.globals.root_url, this.studentid, this.usertoken)
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){                   
                    this.inspdf = data.pdf_url; 
                    this.insvideo = data.video_link; 
                    this.readInsSwal.show();
                    this.loadQPExam(this.qpid);
                    this.spinner.hide();                
                }
                else if(data.status == 1001){
                    this.loading = false;
                    this.router.navigateByUrl('/dashboard');
                }
                else{
                    this.spinner.hide();
                }
            },
            error => {
                this.spinner.hide();
            }
        );
    }
ngAfterViewInit(): void {
    this.readInsSwal.show();
}
exam_id: number = 0;
loadQPExam(id_qp)
{ 
  this.loading = true;
  this.spinner.show();
    this.authenticationService.getEaxmQP(this.globals.root_url, this.studentid, this.usertoken, id_qp)
      .pipe(first())
      .subscribe(
        data => {
          //console.log(data)
          if (data.code == 1000) {
            this.examlist = data.exams; //console.log(this.examlist[0]);
            this.exam_id = this.examlist[0].id_exam
            this.examArrLength = this.examlist.length; 
            if(this.examArrLength == 0)
            {
                this.isAvailableExam = 1;
                this.createExamSwal.show(); 
            }
            else
            {
              this.isAvailableExam = 0;
            }
            this.loading = false;
            this.spinner.hide();
          }
          else {
            this.loading = false;
            this.spinner.hide();
          }
          
        },
        error => {
          //this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
 }
 createExam()
 {
  this.msgSwal.show();
  this.loading = true;
  this.spinner.show();
  const headers = { 'Authorization': 'Bearer '+ this.globals.mockAPIkey};
  //const body = { idExam: exam_id, idStudent: this.studentid };
  //this.http.get<any>("https://admintest.pareekshn.in/ams/createmte?idSector="+this.sectorid+"&idQP="+this.qpid, { headers }).subscribe((res: any) => {
  this.http.get<any>("https://mypanel.pareekshn.com/ams/createmte?idSector="+this.sectorid+"&idQP="+this.qpid, { headers }).subscribe((res: any) => {
      var translateRes = res;
      if (res.status_code == 1000) {
        this.addinBatchSwal.show();
        this.associateinbatch();   
        this.loading = false;
        this.spinner.hide();         
        //this.router.navigateByUrl('/dashboard'); 
      }
      else {
        this.loading = false;
        this.spinner.hide(); 
      }
        
  });
 }
 startexam()
 {
  this.msgSwal.show();
  this.loading = true;
  this.spinner.show();
  const headers = { 'Authorization': 'Bearer '+ this.globals.mockAPIkey};
  //this.http.get<any>("https://admintest.pareekshn.in/ams/addcandidateinbatch?idSelfStudent="+this.studentid+"&idExam="+this.exam_id, { headers }).subscribe((res: any) => {
  this.http.get<any>("https://mypanel.pareekshn.com/ams/addcandidateinbatch?idSelfStudent="+this.studentid+"&idExam="+this.exam_id, { headers }).subscribe((res: any) => {
      var translateRes = res;
      if (res.status_code == 1000) {
        this.loading = false;
        this.spinner.hide();      
        this.router.navigateByUrl('/dashboard'); 
      }
      else {
        this.loading = false;
        this.spinner.hide(); 
        this.router.navigateByUrl('/dashboard'); 
      }
        
  });
    //this.router.navigateByUrl('/dashboard');      
 }
 gotoDashboard()
 {
     this.msgSwal.show();
     this.router.navigateByUrl('/dashboard'); 
 }
 associateinbatch()
 {
      const headers = { 'Authorization': 'Bearer '+ this.globals.mockAPIkey};
      //this.http.get<any>("https://admintest.pareekshn.in/ams/addcandidateinbatch?idSelfStudent="+this.studentid+"&idExam="+this.exam_id, { headers }).subscribe((res: any) => {
      this.http.get<any>("https://mypanel.pareekshn.com/ams/addcandidateinbatch?idSelfStudent="+this.studentid+"&idExam="+this.exam_id, { headers }).subscribe((res: any) => {
      var translateRes = res;
      if (res.status_code == 1000) {
        this.loading = false;
        this.spinner.hide();         
        this.router.navigateByUrl('/dashboard'); 
      }
      else {
        this.loading = false;
        this.spinner.hide(); 
        this.router.navigateByUrl('/dashboard'); 
      }
        
  });
 }
}
